import { SectionList as NbSectionList } from 'native-base';

import { addWithConfig } from '../../utils';

export const SectionList = NbSectionList;

export default addWithConfig(SectionList);
